__webpack_require__.p = "/public-collections-list/";